export function playerOpen() {
    return {
        type: 'GAMEKIT_OPEN_PLAYER'
    };
}

export function playerClose() {
    return {
        type: 'GAMEKIT_CLOSE_PLAYER'
    };
}

export function updateMMSessionData(mmSessionId, mmApiUrl) {
    return { type: 'GAMEKIT_UPDATE_MM_SESSION_DATA', mmSessionId: mmSessionId, mmApiUrl: mmApiUrl };
}
